import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import dayjs from 'dayjs';

import theme from '@styles/theme';

import { FlexBox } from '@components/styled/StyledComponents';

const NoticeListRow = ({ data }: any) => {
    const navigate = useNavigate();

    return (
        <TableRow
            onClick={() => navigate(`/notice/${data?.id}`)}
            $important={data?.important}
        >
            <FlexBox $gap={16}>
                {data?.important && <Tag>중요</Tag>}
                <FlexBox $flexDirection="column" $alignItems="flex-start">
                    <Category>
                        {data.createdAt
                            ? dayjs(data.createdAt).format('YYYY.MM.DD')
                            : '-'}
                    </Category>
                    <Title>{data.title || '-'}</Title>
                </FlexBox>
            </FlexBox>
        </TableRow>
    );
};

export default NoticeListRow;

const TableRow = styled.li<{ $important?: boolean }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 12px 0;
    transition: all 0.25s;
    cursor: pointer;
    &:hover {
        background-color: ${theme.colors.lightGrayHoverColor};
    }

    ${({ $important }) =>
        $important &&
        css`
            padding: 12px 16px;
            background-color: ${theme.colors.ultraLightGrayBorder};
        `};
`;
const Tag = styled.span`
    display: inline-block;
    padding: 4px 6px;
    font-size: 14px;
    font-family: PretendardMedium, sans-serif;
    line-height: 1.2;
    color: ${theme.colors.whiteColor};
    background-color: ${theme.colors.activeOrange};
    border-radius: 16px;
`;
const Category = styled.span`
    display: inline-block;
    margin: 0 0 12px;
    font-size: 14px;
    color: ${theme.colors.deepGrayFontColor};
    line-height: 16px;
`;
const Title = styled.div`
    font-size: 16px;
    font-family: PretendardMedium, sans-serif;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 1.25;
`;
